import { RED, YELLOW, BLUE, ORANGE, GREEN, WHITE, BLACK } from "./colors";
import { Group } from "../geometry/group";
import { Plane } from "../geometry/plane";
import { Triangle } from "../geometry/triangle";
import { Vector3 } from "../math/vector";
export class SkewbNet {
    constructor() {
        const cubeWidth = 1;
        const centerWidth = Math.sqrt(Math.pow(cubeWidth / 2, 2) * 2);
        const orange = new Group(this.makeStickers(ORANGE, centerWidth, Vector3.fromValues(-cubeWidth, 0, 0)));
        const green = new Group(this.makeStickers(GREEN, centerWidth, Vector3.fromValues(2 * cubeWidth, 0, 0)));
        const white = new Group(this.makeStickers(WHITE, centerWidth, Vector3.fromValues(0, -cubeWidth, 0)));
        const red = new Group(this.makeStickers(RED, centerWidth, Vector3.fromValues(cubeWidth, 0, 0)));
        const yellow = new Group(this.makeStickers(YELLOW, centerWidth, Vector3.fromValues(0, cubeWidth, 0)));
        const blue = new Group(this.makeStickers(BLUE, centerWidth, Vector3.fromValues(0, 0, 0)));
        this.U = yellow;
        this.R = red;
        this.F = blue;
        this.L = orange;
        this.B = green;
        this.D = white;
        this.faces = {
            top: this.U,
            front: this.F,
            right: this.R,
            back: this.B,
            left: this.L,
            bottom: this.D,
        };
        this.stickers = [red, yellow, blue, orange, green, white];
        this.group = new Group(this.stickers);
        this.group.translate(-cubeWidth / 4, 0, 0);
        this.group.scale(0.5, 0.5, 0.5);
    }
    makeStickers(color, width, translate) {
        const center = new Plane(width, width, color);
        center.translate(translate.x, translate.y, translate.z);
        center.rotate(Math.PI / 4, 0, 0, 1);
        center.translate(-width / 2, width / 2, 0);
        const triangles = [];
        for (let i = 0; i < 4; i++) {
            const triangle = new Triangle(Vector3.fromValues(-width / 2, width / 2, 0), Vector3.fromValues(0, width, 0), Vector3.fromValues(width / 2, width / 2, 0), color);
            triangle.translate(translate.x, translate.y, translate.z);
            triangle.rotate((-Math.PI / 2) * i, 0, 0, 1);
            triangle.rotate(Math.PI / 4, 0, 0, 1);
            triangles.push(triangle);
        }
        return [center, ...triangles];
    }
    setColors(colors) {
        let { top, right, front, bottom, left, back } = colors;
        this.setFaceColors(this.U, top);
        this.setFaceColors(this.R, right);
        this.setFaceColors(this.F, front);
        this.setFaceColors(this.D, bottom);
        this.setFaceColors(this.L, left);
        this.setFaceColors(this.B, back);
    }
    setFaceColors(faceStickers, colors = []) {
        faceStickers.objects[0].faces[0].color = colors[0] || BLACK;
        faceStickers.objects[1].faces[0].color = colors[1] || BLACK;
        faceStickers.objects[2].faces[0].color = colors[2] || BLACK;
        faceStickers.objects[3].faces[0].color = colors[4] || BLACK; // Setting 3 -> 4 and 4 -> 3 now because 4 and 3 are stored incorrectly in this class.
        faceStickers.objects[4].faces[0].color = colors[3] || BLACK;
    }
}
